import { render } from "./swiperImagesComponent.vue?vue&type=template&id=89c883b8"
import script from "./swiperImagesComponent.vue?vue&type=script&lang=js"
export * from "./swiperImagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__